import { createCustomEnum } from "./customEnum";

const TerminalTypes = createCustomEnum({
	None: {
		value: 0,
		name: "None",
		displayName: "None",
	},
	Purchase: {
		value: 1,
		name: "Purchase",
		displayName: "Purchase",
	},
	RentToOwn: {
		value: 2,
		name: "RentToOwn",
		displayName: "Rent to Own",
	},
	Rental: {
		value: 3,
		name: "Rental",
		displayName: "Rental",
	},
	Reprogram: {
		value: 4,
		name: "Reprogram",
		displayName: "Reprogram",
	},
	FreePlacement: {
		value: 5,
		name: "FreePlacement",
		displayName: "Free Placement",
	},
	Loaner: {
		value: 6,
		name: "Loaner",
		displayName: "Loaner",
	},
	WarrantyProgram: {
		value: 7,
		name: "WarrantyProgram",
		displayName: "Warranty Program",
	},
	Lease: {
		value: 8,
		name: "Lease",
		displayName: "Lease",
	},
	ExistingTerminal: {
		value: 9,
		name: "ExistingTerminal",
		displayName: "Existing Terminal",
	},
});

export default TerminalTypes;
